export default class MediaAPI {
  static async getSrc(id: number) {
    let response = await(fetch(
      process.env.REACT_APP_SERVER_URL + '/media/' + id,
      {
        method: 'GET',
        headers: { 'content-type': 'application/json;charset-UTF-8' }
      }
    ));
    if (!response.ok) {
      console.error("Error getting media src:", response);
      throw new Error(`HTTP error. status: ${response.status}`);
    }
    let result = await response.json();
    return result.guid.rendered;
  }

  static async getAffiliateSRC(slug: string) {
    let response = await(fetch(
      process.env.REACT_APP_API_URL + 'wp-json/mmr/v1/affiliate_image?slug=' + slug,
      {
        method: 'GET',
        headers: { 'content-type': 'application/json;charset-UTF-8' }
      }
    ));
    if (!response.ok) {
      console.error("Error getting media src:", response);
      throw new Error(`HTTP error. status: ${response.status}`);
    }
    let result = await response.json();
    return result.affiliate_image_url.full_url;
  }

  static async getNutritionSrc(id: number) {
    let response = await(fetch(
      process.env.REACT_APP_SERVER_URL + '/media/' + id,
      {
        method: 'GET',
        headers: { 'content-type': 'application/json;charset-UTF-8' }
      }
    ));
    if (!response.ok) {
      console.error("Error getting media src:", response);
      throw new Error(`HTTP error. status: ${response.status}`);
    }
    let result = await response.json();
    return result.source_url;
  }

}